import {
  FETCH_DISCOUNT,
  RESET_DISCOUNT,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const discountViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISCOUNT:
      return { data: action.payload };
    case RESET_DISCOUNT:
      return initialState;
    default:
      return state;
  }
};

export default discountViewReducer;
